import qs from "qs";
import environment from "environment";
import { requestService } from "../request";
import type { DropDownObjItemType, Dictionaries } from "../../reducers/dictionaries";

export type Data = {
  "data": Array<DropDownObjItemType>,
}

// eslint-disable-next-line import/prefer-default-export,max-len
export const getDropdownList: (type: Dictionaries, filter?: string, performer?: string) => Promise<Data> = (type, filter, performer) => requestService
  .get(environment.endpoints.get.getDropdownList, {
    params: { type, performer, filter },
    paramsSerializer: (params: any): string => qs.stringify(params, { arrayFormat: "brackets", encode: false }),
  });
